// extracted by mini-css-extract-plugin
module.exports = {"Root":"accordion_Root__jxjYW","Arrow":"accordion_Arrow__jEDj8","ArrowOpen":"accordion_ArrowOpen__nlXM6 accordion_Arrow__jEDj8","Accordin":"accordion_Accordin__vzlpG"};